import { useState } from 'react';
import s from '../../styles/components/booking/FaqList.module.css';

export default function FaqList({ data }) {
  const { image, imageAlt, eyebrow, headline, items } = data;
  const [open, setOpen] = useState(null);

  return (
    <section className={s.container}>
      <div className={s.media}>
        <img src={image} alt={imageAlt} className={s.image} />
      </div>

      <div className={s.inner}>
        <span className={s.eyebrow}>{eyebrow}</span>
        <h1 className={s.headline}>{headline}</h1>

        <div className={s.list}>
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className={s.item}>
                <button
                  className={s.question}
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <span>{item.q}</span>
                  <span className={`${s.icon} ${isOpen ? s.iconOpen : ''}`}>+</span>
                </button>
                <div className={`${s.answerWrap} ${isOpen ? s.answerOpen : ''}`}>
                  <p className={s.answer}>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}